import { Component, OnInit, AfterViewInit, ElementRef, Renderer2, Input } from '@angular/core';

@Component({
  selector: 'app-baidu-shared',
  templateUrl: './baidu-shared.component.html',
  styleUrls: ['./baidu-shared.component.scss']
})
export class BaiduSharedComponent implements OnInit, AfterViewInit {


  @Input() title: string = '';
  @Input() desc: string = '';
  @Input() url: string = '';

  constructor(private _el: ElementRef) {



  }

  ngOnInit() {
    if(this.url === ''){
      this.url = window.location.href;
    }
    window['_bd_share_config'] = {
      common: {
        bdText: this.title,
        bdDesc: this.desc,
        bdUrl: this.url,
      },
      share: [{
        "bdSize": 32
      }]
    };
  }

  ngAfterViewInit() {


    const script = document.createElement('script');
    script.src = 'http://bdimg.share.baidu.com/static/api/js/share.js?cdnversion=' + ~(-new Date() / 36e5);
    script.type = 'text/javascript';
    script.defer = true;
    document.body.appendChild(script);
    // this._renderer.(this._el, script);
  }


}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/baidu-shared/baidu-shared.component.ts